import { Box } from '@mui/material';
import React, { ReactNode } from 'react';

import { Header } from 'components/Header/MainHeader';

export const DashboardLayout = ({ children }: { children: ReactNode }) => {
	return (
		<Box
			sx={{
				boxSizing: 'border-box',
				display: 'flex',
				height: '100vh',
				padding: '12px 18px',
				overflow: 'hidden',
			}}
			className="rtl-able"
		>
			<Header />

			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					width: '100%',
					height: '100%',
					flex: 1,
					overflow: 'hidden',
				}}
				className="rtl-able"
			>
				<Box
					sx={{
						display: 'flex',
						width: '100%',
						height: '100%',
						justifyContent: 'flex-start',
						overflow: 'hidden',
					}}
				>
					<Box
						sx={{
							width: '100%',
							height: '100%',
							display: 'flex',
							overflowY: 'auto',
							overflowX: 'hidden',
							backgroundColor: '#EFEFEF',
							boxSizing: 'border-box',
						}}
					>
						<Box
							position="relative"
							display={'flex'}
							flexDirection={'column'}
							flexGrow={1}
							height="100%"
						>
							{children}
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};